import { render } from "./ProjectQuickActions.vue?vue&type=template&id=1b35300d"
import script from "./ProjectQuickActions.vue?vue&type=script&lang=js"
export * from "./ProjectQuickActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__